import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseCustomersManagement() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetCustomersList = (myPC, search, bool, callback) => {
    let newMyPc = myPC;
    if (myPC.sortColumn == "SuspendTitle") {
      newMyPc.sortColumn = "IsSuspend";
    }
    if (myPC.sortColumn == "GenderTitle") {
      newMyPc.sortColumn = "Gender";
    }
    MyAxios.get(`Admin_Customers?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SuspendCustomer = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Customers/suspend`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    validate,
    GetCustomersList,
    SuspendCustomer,
  };
}
